import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47de62d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row lockHeader" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subheader col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "受注情報入力")
], -1))
const _hoisted_4 = {
  class: "subheader-block ml-auto demo col-lg-9",
  style: {"text-align":"right"}
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-copy mr-1" }, null, -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-paper-plane mr-1" }, null, -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-file-export mr-1" }, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lockHeaderSpacer" }, null, -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-xl-12" }
const _hoisted_22 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "基本情報"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_24 = {
  class: "panel-container show",
  id: "panel-editers"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_26 = { class: "panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-auto ml-auto" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"15px"} }, "案件種類", -1))
const _hoisted_32 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioSelling"
}, "売上", -1))
const _hoisted_34 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioWip"
}, "仕掛", -1))
const _hoisted_36 = { class: "col-sm-6" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"15px"} }, "入金方法", -1))
const _hoisted_38 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioBulk"
}, "一括", -1))
const _hoisted_40 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioSplit"
}, "分割", -1))
const _hoisted_42 = { class: "panel-content contents" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "案件番号", -1))
const _hoisted_45 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "案件名", -1))
const _hoisted_50 = { class: "col-md-5 contCnt" }
const _hoisted_51 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "広告主", -1))
const _hoisted_54 = { class: "col-md-5 contCnt" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求先", -1))
const _hoisted_56 = { class: "col-md-5 contCnt input-group selectedClear radiuszero4right" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "広告内容", -1))
const _hoisted_59 = { class: "col-md-5 contCnt" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "営業担当", -1))
const _hoisted_61 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-1 contTitle\" data-v-47de62d9>契約書<br data-v-47de62d9>【MD様検討中】</div><div class=\"col-md-5 contCnt\" data-v-47de62d9><div class=\"input-group\" data-v-47de62d9><div class=\"custom-file\" data-v-47de62d9><input type=\"file\" class=\"custom-file-input\" id=\"inputGroupFile04\" aria-describedby=\"inputGroupFileAddon04\" data-v-47de62d9><label class=\"custom-file-label\" style=\"white-space:nowrap;height:35px;\" for=\"inputGroupFile04\" data-v-47de62d9>ファイルを選択してください</label></div><div class=\"input-group-append\" data-v-47de62d9><button class=\"btn btn-outline-default waves-effect waves-themed\" type=\"button\" id=\"inputGroupFileAddon04\" data-v-47de62d9> 表示 </button><button class=\"btn btn-outline-default waves-effect waves-themed\" type=\"button\" id=\"inputGroupFileAddon04\" data-v-47de62d9> 削除 </button></div></div></div><div class=\"col-md-1 contTitle\" data-v-47de62d9>アラート</div>", 3)
const _hoisted_66 = { class: "col-md-5 contCnt" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, [
  /*#__PURE__*/_createTextVNode(" ファイルリスト"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("【MD様検討中】 ")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "file_result",
    style: {"overflow-y":"scroll","overflow-x":"hidden","height":"100%","margin":"0px"}
  }, [
    /*#__PURE__*/_createElementVNode("table", {
      class: "file_list",
      id: "file_list",
      style: {"margin":"0px","padding":"0px","width":"100%"}
    })
  ])
], -1))
const _hoisted_70 = { class: "col-md-6 contCnt" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-info-200 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>3,4,5,8,2</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"3\" fill=\"#fff\" x=\"0.54\" y=\"16.875\" width=\"4.32\" height=\"10.125\" data-v-47de62d9></rect><rect data-value=\"4\" fill=\"#fff\" x=\"5.94\" y=\"13.5\" width=\"4.319999999999999\" height=\"13.5\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"11.34\" y=\"10.125\" width=\"4.32\" height=\"16.875\" data-v-47de62d9></rect><rect data-value=\"8\" fill=\"#fff\" x=\"16.740000000000002\" y=\"0\" width=\"4.319999999999997\" height=\"27\" data-v-47de62d9></rect><rect data-value=\"2\" fill=\"#fff\" x=\"22.139999999999997\" y=\"20.25\" width=\"4.320000000000004\" height=\"6.75\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "売上合計", -1))
const _hoisted_75 = { class: "font-weight-bold mb-0" }
const _hoisted_76 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-info-300 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>5,3,1,7,9</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"5\" fill=\"#fff\" x=\"0.54\" y=\"12\" width=\"4.32\" height=\"15\" data-v-47de62d9></rect><rect data-value=\"3\" fill=\"#fff\" x=\"5.94\" y=\"18\" width=\"4.319999999999999\" height=\"9\" data-v-47de62d9></rect><rect data-value=\"1\" fill=\"#fff\" x=\"11.34\" y=\"24\" width=\"4.32\" height=\"3\" data-v-47de62d9></rect><rect data-value=\"7\" fill=\"#fff\" x=\"16.740000000000002\" y=\"6\" width=\"4.319999999999997\" height=\"21\" data-v-47de62d9></rect><rect data-value=\"9\" fill=\"#fff\" x=\"22.139999999999997\" y=\"0\" width=\"4.320000000000004\" height=\"27\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "仕入合計", -1))
const _hoisted_79 = { class: "font-weight-bold mb-0" }
const _hoisted_80 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-success-300 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>3,4,3,5,5</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"3\" fill=\"#fff\" x=\"0.54\" y=\"10.8\" width=\"4.32\" height=\"16.2\" data-v-47de62d9></rect><rect data-value=\"4\" fill=\"#fff\" x=\"5.94\" y=\"5.399999999999999\" width=\"4.319999999999999\" height=\"21.6\" data-v-47de62d9></rect><rect data-value=\"3\" fill=\"#fff\" x=\"11.34\" y=\"10.8\" width=\"4.32\" height=\"16.2\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"16.740000000000002\" y=\"0\" width=\"4.319999999999997\" height=\"27\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"22.139999999999997\" y=\"0\" width=\"4.320000000000004\" height=\"27\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "利益", -1))
const _hoisted_83 = { class: "font-weight-bold mb-0" }
const _hoisted_84 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_85 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-success-500 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>6,4,7,5,6</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"6\" fill=\"#fff\" x=\"0.54\" y=\"3.8571428571428577\" width=\"4.32\" height=\"23.142857142857142\" data-v-47de62d9></rect><rect data-value=\"4\" fill=\"#fff\" x=\"5.94\" y=\"11.571428571428573\" width=\"4.319999999999999\" height=\"15.428571428571427\" data-v-47de62d9></rect><rect data-value=\"7\" fill=\"#fff\" x=\"11.34\" y=\"0\" width=\"4.32\" height=\"27\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"16.740000000000002\" y=\"7.714285714285715\" width=\"4.319999999999997\" height=\"19.285714285714285\" data-v-47de62d9></rect><rect data-value=\"6\" fill=\"#fff\" x=\"22.139999999999997\" y=\"3.8571428571428577\" width=\"4.320000000000004\" height=\"23.142857142857142\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "利益率", -1))
const _hoisted_87 = { class: "font-weight-bold mb-0" }
const _hoisted_88 = { class: "row" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 contTitle" }, "備考", -1))
const _hoisted_90 = { class: "col-md-12" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-xl-12" }
const _hoisted_93 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "明細"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_95 = {
  class: "panel-container show",
  id: "panel-editers4det"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_97 = { class: "panel-content contents" }
const _hoisted_98 = { class: "dispNone cloneCont" }
const _hoisted_99 = {
  class: "row",
  style: {"border-bottom":"1px solid #e5e5e5"}
}
const _hoisted_100 = { class: "col-auto" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-sm-6" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"15px"} }, "案件種類", -1))
const _hoisted_104 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioSellingClone"
}, "売上", -1))
const _hoisted_106 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioWipClone"
}, "仕掛", -1))
const _hoisted_108 = { class: "col-sm-6" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"15px"} }, "入金方法", -1))
const _hoisted_110 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioBulkClone"
}, "一括", -1))
const _hoisted_112 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "radioSplitClone"
}, "分割", -1))
const _hoisted_114 = { class: "row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "案件番号", -1))
const _hoisted_116 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_117 = ["disabled"]
const _hoisted_118 = ["disabled"]
const _hoisted_119 = ["disabled"]
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "案件名", -1))
const _hoisted_121 = { class: "col-md-5 contCnt" }
const _hoisted_122 = { class: "row" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "広告主", -1))
const _hoisted_124 = { class: "col-md-5 contCnt" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求先", -1))
const _hoisted_126 = { class: "col-md-5 contCnt input-group selectedClear radiuszero4right" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "広告内容", -1))
const _hoisted_129 = { class: "col-md-5 contCnt" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "営業担当", -1))
const _hoisted_131 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_132 = { class: "row" }
const _hoisted_133 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-1 contTitle\" data-v-47de62d9> 契約書<br data-v-47de62d9>【MD様検討中】 </div><div class=\"col-md-5 contCnt\" data-v-47de62d9><div class=\"input-group\" data-v-47de62d9><div class=\"custom-file\" data-v-47de62d9><input type=\"file\" class=\"custom-file-input\" id=\"inputGroupFile04\" aria-describedby=\"inputGroupFileAddon04\" data-v-47de62d9><label class=\"custom-file-label\" style=\"white-space:nowrap;height:35px;\" for=\"inputGroupFile04\" data-v-47de62d9>ファイルを選択してください</label></div><div class=\"input-group-append\" data-v-47de62d9><button class=\"btn btn-outline-default waves-effect waves-themed\" type=\"button\" id=\"inputGroupFileAddon04\" data-v-47de62d9> 表示 </button><button class=\"btn btn-outline-default waves-effect waves-themed\" type=\"button\" id=\"inputGroupFileAddon04\" data-v-47de62d9> 削除 </button></div></div></div><div class=\"col-md-1 contTitle\" data-v-47de62d9>アラート</div>", 3)
const _hoisted_136 = { class: "col-md-5 contCnt" }
const _hoisted_137 = { class: "row" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, [
  /*#__PURE__*/_createTextVNode(" ファイルリスト"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("【MD様検討中】 ")
], -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "file_result",
    style: {"overflow-y":"scroll","overflow-x":"hidden","height":"100%","margin":"0px"}
  }, [
    /*#__PURE__*/_createElementVNode("table", {
      class: "file_list",
      id: "file_list",
      style: {"margin":"0px","padding":"0px","width":"100%"}
    })
  ])
], -1))
const _hoisted_140 = { class: "col-md-6 contCnt" }
const _hoisted_141 = { class: "row" }
const _hoisted_142 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_143 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-info-200 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>3,4,5,8,2</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"3\" fill=\"#fff\" x=\"0.54\" y=\"16.875\" width=\"4.32\" height=\"10.125\" data-v-47de62d9></rect><rect data-value=\"4\" fill=\"#fff\" x=\"5.94\" y=\"13.5\" width=\"4.319999999999999\" height=\"13.5\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"11.34\" y=\"10.125\" width=\"4.32\" height=\"16.875\" data-v-47de62d9></rect><rect data-value=\"8\" fill=\"#fff\" x=\"16.740000000000002\" y=\"0\" width=\"4.319999999999997\" height=\"27\" data-v-47de62d9></rect><rect data-value=\"2\" fill=\"#fff\" x=\"22.139999999999997\" y=\"20.25\" width=\"4.320000000000004\" height=\"6.75\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "売上合計", -1))
const _hoisted_145 = { class: "font-weight-bold mb-0" }
const _hoisted_146 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_147 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-info-300 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>5,3,1,7,9</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"5\" fill=\"#fff\" x=\"0.54\" y=\"12\" width=\"4.32\" height=\"15\" data-v-47de62d9></rect><rect data-value=\"3\" fill=\"#fff\" x=\"5.94\" y=\"18\" width=\"4.319999999999999\" height=\"9\" data-v-47de62d9></rect><rect data-value=\"1\" fill=\"#fff\" x=\"11.34\" y=\"24\" width=\"4.32\" height=\"3\" data-v-47de62d9></rect><rect data-value=\"7\" fill=\"#fff\" x=\"16.740000000000002\" y=\"6\" width=\"4.319999999999997\" height=\"21\" data-v-47de62d9></rect><rect data-value=\"9\" fill=\"#fff\" x=\"22.139999999999997\" y=\"0\" width=\"4.320000000000004\" height=\"27\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "仕入合計", -1))
const _hoisted_149 = { class: "font-weight-bold mb-0" }
const _hoisted_150 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_151 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-success-300 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>3,4,3,5,5</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"3\" fill=\"#fff\" x=\"0.54\" y=\"10.8\" width=\"4.32\" height=\"16.2\" data-v-47de62d9></rect><rect data-value=\"4\" fill=\"#fff\" x=\"5.94\" y=\"5.399999999999999\" width=\"4.319999999999999\" height=\"21.6\" data-v-47de62d9></rect><rect data-value=\"3\" fill=\"#fff\" x=\"11.34\" y=\"10.8\" width=\"4.32\" height=\"16.2\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"16.740000000000002\" y=\"0\" width=\"4.319999999999997\" height=\"27\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"22.139999999999997\" y=\"0\" width=\"4.320000000000004\" height=\"27\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "利益", -1))
const _hoisted_153 = { class: "font-weight-bold mb-0" }
const _hoisted_154 = { class: "col-6 col-xl-3 d-sm-flex align-items-center" }
const _hoisted_155 = /*#__PURE__*/_createStaticVNode("<div class=\"p-2 mr-3 bg-success-500 rounded\" data-v-47de62d9><span class=\"peity-bar\" data-peity=\"{&quot;fill&quot;: [&quot;#fff&quot;], &quot;width&quot;: 27, &quot;height&quot;: 27 }\" style=\"display:none;\" data-v-47de62d9>6,4,7,5,6</span><svg class=\"peity\" height=\"27\" width=\"27\" data-v-47de62d9><rect data-value=\"6\" fill=\"#fff\" x=\"0.54\" y=\"3.8571428571428577\" width=\"4.32\" height=\"23.142857142857142\" data-v-47de62d9></rect><rect data-value=\"4\" fill=\"#fff\" x=\"5.94\" y=\"11.571428571428573\" width=\"4.319999999999999\" height=\"15.428571428571427\" data-v-47de62d9></rect><rect data-value=\"7\" fill=\"#fff\" x=\"11.34\" y=\"0\" width=\"4.32\" height=\"27\" data-v-47de62d9></rect><rect data-value=\"5\" fill=\"#fff\" x=\"16.740000000000002\" y=\"7.714285714285715\" width=\"4.319999999999997\" height=\"19.285714285714285\" data-v-47de62d9></rect><rect data-value=\"6\" fill=\"#fff\" x=\"22.139999999999997\" y=\"3.8571428571428577\" width=\"4.320000000000004\" height=\"23.142857142857142\" data-v-47de62d9></rect></svg></div>", 1)
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-sm mb-0" }, "利益率", -1))
const _hoisted_157 = { class: "font-weight-bold mb-0" }
const _hoisted_158 = { class: "row" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 contTitle" }, "備考", -1))
const _hoisted_160 = { class: "col-md-12" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spacer",
  style: {"height":"150px"}
}, null, -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_163 = { class: "text-success fw-500" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_168 = { class: "modal-footer" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_171 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Or_tableJyutu = _resolveComponent("Or_tableJyutu")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!
  const _component_Or_insurance = _resolveComponent("Or_insurance")!
  const _component_Or_selectClient = _resolveComponent("Or_selectClient")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cpyProject()))
            }, [
              _hoisted_6,
              _createTextVNode("案件コピー ")
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal4insurance()))
            }, [
              _hoisted_8,
              _createTextVNode("保険申請 ")
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dl()))
            }, [
              _hoisted_10,
              _createTextVNode("画面印刷 ")
            ], 8, _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.creClaim($event)))
            }, [
              _hoisted_12,
              _createTextVNode("請求書・納品書作成 ")
            ], 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              class: "btn btn-danger waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.delConf()))
            }, [
              _hoisted_14,
              _createTextVNode("削除 ")
            ], 8, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              type: "button",
              class: "btn btn-info waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.upd(false, false)))
            }, [
              _hoisted_16,
              _createTextVNode("登録 ")
            ], 8, _hoisted_15))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 6,
              type: "button",
              class: "btn btn-info waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.add()))
            }, [
              _hoisted_18,
              _createTextVNode("新規登録 ")
            ], 8, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "custom-control-input",
                          id: "radioSelling",
                          name: "radioProjectType",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.c_project_type) = $event)),
                          value: "2"
                        }, null, 512), [
                          [_vModelRadio, _ctx.delegate.c_project_type]
                        ]),
                        _hoisted_33
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "custom-control-input",
                          id: "radioWip",
                          name: "radioProjectType",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delegate.c_project_type) = $event)),
                          value: "3"
                        }, null, 512), [
                          [_vModelRadio, _ctx.delegate.c_project_type]
                        ]),
                        _hoisted_35
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "custom-control-input",
                          id: "radioBulk",
                          name: "radioBillingMethod",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.c_project_billing_type) = $event)),
                          value: "1"
                        }, null, 512), [
                          [_vModelRadio, _ctx.delegate.c_project_billing_type]
                        ]),
                        _hoisted_39
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "custom-control-input",
                          id: "radioSplit",
                          name: "radioBillingMethod",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.c_project_billing_type) = $event)),
                          value: "2"
                        }, null, 512), [
                          [_vModelRadio, _ctx.delegate.c_project_billing_type]
                        ]),
                        _hoisted_41
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    id: "jyutyuNumber",
                    type: "text",
                    class: "form-control form-control-sm",
                    readonly: "true",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.jyutyuNumber) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.jyutyuNumber]
                  ]),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: "検索",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/ankenlist'))),
                    disabled: _ctx.btnDisable
                  }, null, 8, _hoisted_46),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: "<<",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goPrev())),
                    disabled: _ctx.btnDisable
                  }, null, 8, _hoisted_47),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: ">>",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goNext())),
                    disabled: _ctx.btnDisable
                  }, null, 8, _hoisted_48)
                ]),
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtAnkenNm",
                    id: "txtAnkenNm",
                    maxlength: "200",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delegate.c_project_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_project_name]
                  ]),
                  (_ctx.errors?.path === 'pjName')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKoukokuNm",
                    id: "txtKoukokuNm",
                    maxlength: "200",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.delegate.c_project_sponsor_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_project_sponsor_name]
                  ])
                ]),
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegate4list.items4Client,
                    modelValue: _ctx.delegate.c_client_id,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.delegate.c_client_id) = $event)),
                    label: "c_client_name",
                    reduce: (label) => label.c_client_id,
                    style: {"width":"80%"}
                  }, null, 8, ["options", "modelValue", "reduce"]),
                  _createElementVNode("input", {
                    type: "button",
                    class: "btn-primary form-control form-control-sm",
                    value: "検索",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showModalclaim()))
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKoukokuNm",
                    id: "txtKoukokuNm",
                    maxlength: "200",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.delegate.c_project_cont) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_project_cont]
                  ])
                ]),
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.getOpStaffs(),
                    modelValue: _ctx.delegate.c_staff_id,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_staff_id) = $event)),
                    label: "c_staff_name",
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opAlertContract,
                    modelValue: _ctx.delegate.c_project_alert,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.delegate.c_project_alert) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("div", null, [
                        _hoisted_74,
                        _createElementVNode("h4", _hoisted_75, " ￥" + _toDisplayString(_ctx.profitDatas.sumSales) + "- ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("div", null, [
                        _hoisted_78,
                        _createElementVNode("h4", _hoisted_79, " ￥" + _toDisplayString(_ctx.profitDatas.sumSupplys) + "- ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createElementVNode("div", null, [
                        _hoisted_82,
                        _createElementVNode("h4", _hoisted_83, " ￥" + _toDisplayString(_ctx.profitDatas.profit) + "- ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createElementVNode("div", null, [
                        _hoisted_86,
                        _createElementVNode("h4", _hoisted_87, _toDisplayString(_ctx.profitDatas.profitRatio) + "% ", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _hoisted_89,
                _createElementVNode("div", _hoisted_90, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "txtBiko",
                    id: "txtBiko",
                    class: "example2 form-control",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.remarks) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.remarks]
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_91, [
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _hoisted_94,
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _createElementVNode("div", _hoisted_104, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "custom-control-input",
                            id: "radioSellingClone",
                            name: "radioProjectTypeClone",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.delegate.c_project_type) = $event)),
                            value: "2"
                          }, null, 512), [
                            [_vModelRadio, _ctx.delegate.c_project_type]
                          ]),
                          _hoisted_105
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "custom-control-input",
                            id: "radioWipClone",
                            name: "radioProjectTypeClone",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.delegate.c_project_type) = $event)),
                            value: "3"
                          }, null, 512), [
                            [_vModelRadio, _ctx.delegate.c_project_type]
                          ]),
                          _hoisted_107
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _createElementVNode("div", _hoisted_110, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "custom-control-input",
                            id: "radioBulkClone",
                            name: "radioBillingMethodClone",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delegate.c_project_billing_type) = $event)),
                            value: "1"
                          }, null, 512), [
                            [_vModelRadio, _ctx.delegate.c_project_billing_type]
                          ]),
                          _hoisted_111
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "custom-control-input",
                            id: "radioSplitClone",
                            name: "radioBillingMethodClone",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.delegate.c_project_billing_type) = $event)),
                            value: "2"
                          }, null, 512), [
                            [_vModelRadio, _ctx.delegate.c_project_billing_type]
                          ]),
                          _hoisted_113
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_114, [
                  _hoisted_115,
                  _createElementVNode("div", _hoisted_116, [
                    _withDirectives(_createElementVNode("input", {
                      id: "jyutyuNumber",
                      type: "text",
                      class: "form-control form-control-sm",
                      readonly: "true",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.jyutyuNumber) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.jyutyuNumber]
                    ]),
                    _createElementVNode("input", {
                      type: "button",
                      class: "btn-primary form-control form-control-sm",
                      value: "検索",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$router.push('/ankenlist'))),
                      disabled: _ctx.btnDisable
                    }, null, 8, _hoisted_117),
                    _createElementVNode("input", {
                      type: "button",
                      class: "btn-primary form-control form-control-sm",
                      value: "<<",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.goPrev())),
                      disabled: _ctx.btnDisable
                    }, null, 8, _hoisted_118),
                    _createElementVNode("input", {
                      type: "button",
                      class: "btn-primary form-control form-control-sm",
                      value: ">>",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.goNext())),
                      disabled: _ctx.btnDisable
                    }, null, 8, _hoisted_119)
                  ]),
                  _hoisted_120,
                  _createElementVNode("div", _hoisted_121, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "txtAnkenNm",
                      id: "txtAnkenNm",
                      maxlength: "200",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.delegate.c_project_name) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.delegate.c_project_name]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_122, [
                  _hoisted_123,
                  _createElementVNode("div", _hoisted_124, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "txtKoukokuNm",
                      id: "txtKoukokuNm",
                      maxlength: "200",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.delegate.c_project_sponsor_name) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.delegate.c_project_sponsor_name]
                    ])
                  ]),
                  _hoisted_125,
                  _createElementVNode("div", _hoisted_126, [
                    _createVNode(_component_vSelect, {
                      options: _ctx.delegate4list.items4Client,
                      modelValue: _ctx.delegate.c_client_id,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.delegate.c_client_id) = $event)),
                      label: "c_client_name",
                      reduce: (label) => label.c_client_id,
                      style: {"width":"80%"}
                    }, null, 8, ["options", "modelValue", "reduce"]),
                    _createElementVNode("input", {
                      type: "button",
                      class: "btn-primary form-control form-control-sm",
                      value: "検索",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showModalclaim()))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_127, [
                  _hoisted_128,
                  _createElementVNode("div", _hoisted_129, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "txtKoukokuNm",
                      id: "txtKoukokuNm",
                      maxlength: "200",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.delegate.c_project_cont) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.delegate.c_project_cont]
                    ])
                  ]),
                  _hoisted_130,
                  _createElementVNode("div", _hoisted_131, [
                    _createVNode(_component_vSelect, {
                      options: _ctx.getOpStaffs(),
                      modelValue: _ctx.delegate.c_staff_id,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.delegate.c_staff_id) = $event)),
                      label: "c_staff_name",
                      reduce: (label) => label.c_staff_id
                    }, null, 8, ["options", "modelValue", "reduce"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_132, [
                  _hoisted_133,
                  _createElementVNode("div", _hoisted_136, [
                    _createVNode(_component_vSelect, {
                      options: _ctx.opAlertContract,
                      modelValue: _ctx.delegate.c_project_alert,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.delegate.c_project_alert) = $event)),
                      reduce: (label) => label.code
                    }, null, 8, ["options", "modelValue", "reduce"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_137, [
                  _hoisted_138,
                  _hoisted_139,
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("div", _hoisted_142, [
                        _hoisted_143,
                        _createElementVNode("div", null, [
                          _hoisted_144,
                          _createElementVNode("h4", _hoisted_145, " ￥" + _toDisplayString(_ctx.profitDatas.sumSales) + "- ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_146, [
                        _hoisted_147,
                        _createElementVNode("div", null, [
                          _hoisted_148,
                          _createElementVNode("h4", _hoisted_149, " ￥" + _toDisplayString(_ctx.profitDatas.sumSupplys) + "- ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_150, [
                        _hoisted_151,
                        _createElementVNode("div", null, [
                          _hoisted_152,
                          _createElementVNode("h4", _hoisted_153, " ￥" + _toDisplayString(_ctx.profitDatas.profit) + "- ", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_154, [
                        _hoisted_155,
                        _createElementVNode("div", null, [
                          _hoisted_156,
                          _createElementVNode("h4", _hoisted_157, _toDisplayString(_ctx.profitDatas.profitRatio) + "% ", 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_158, [
                  _hoisted_159,
                  _createElementVNode("div", _hoisted_160, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "txtBiko",
                      id: "txtBiko",
                      class: "example2 form-control",
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.remarks) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.remarks]
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_Or_tableJyutu, {
                ref: "or_tableJyutu",
                projectData: _ctx.delegate,
                "onUpdate:projectData": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.delegate) = $event)),
                profitData: _ctx.profitDatas,
                "onUpdate:profitData": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.profitDatas) = $event)),
                mastersData: _ctx.delegate4list,
                "onUpdate:mastersData": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.delegate4list) = $event))
              }, null, 8, ["projectData", "profitData", "mastersData"])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_161,
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[42] || (_cache[42] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_162,
        _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_164
      ]),
      footer: _withCtx(() => [
        _hoisted_165
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_166,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_167
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_168, [
          _createElementVNode("button", {
            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_169,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConfBody), 1),
        _hoisted_170
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("button", {
            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Or_insurance, {
      ref: "comp_insurance",
      onInsura_comp: _cache[46] || (_cache[46] = ($event: any) => (_ctx.insuraComp())),
      onInsura_none: _cache[47] || (_cache[47] = ($event: any) => (_ctx.insuraNone())),
      projectDataInsura: _ctx.delegate,
      "onUpdate:projectDataInsura": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.delegate) = $event))
    }, null, 8, ["projectDataInsura"]),
    _createVNode(_component_Or_selectClient, {
      ref: "Mo_modal_selectType",
      evDatas: _ctx.evDatas,
      "onUpdate:evDatas": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.evDatas) = $event))
    }, null, 8, ["evDatas"])
  ]))
}